<script src="./Remove.js"></script>
<template>
  <a
    href="#"
    @click.prevent="removeLineItem"
    data-test="cart-line-item-delete"
    ><i class="fa fa-trash-o"></i
  ></a>
</template>
